angular
    .module('app')
    .component('winbackOffersList', {
        templateUrl: '/templates/pages/winback-offers/winback-offers-list/winback-offers-list.html',
        controller: 'WinbackOffersListController',
        controllerAs: 'vm',
    });